import NetMsgDataToBuffer from "../../../framework/net/net_msgdata_to_buffer";
import { K9Proto } from "./proto/proto_k9_game";
import { K9Room } from "./proto/proto_k9_room";

export class NetMsgK9 extends NetMsgDataToBuffer {
    //发送命令名|发送结构体|收包命令|收包结构体|协议类型:1为登录服，2为麻将游戏服，3为Skynet扑克服
    //登陆或重连发送的数据
    static GameInfo: any[] = [null, null, "Game.GameInfo",K9Proto.GameInfo, 3];

    static LeaveRoomNotify: any[] = [null, null, "Room.LeaveBroadcast", K9Room.LeaveBroadcast, 3]

    static LeaveRoom: any[] = ["Room.LeaveReq", K9Room.LeaveReq, "Room.LeaveRsp", K9Room.LeaveRsp, 3]

    static TimeoutNotify:any[] = [null, null, "Game.TimeoutNotify",K9Proto.TimeoutNotify, 3];

    static BankerQueueNotify: any[] = [null, null, "Game.BankerQueueNotify", K9Proto.BankerQueueNotify, 3]

    static Banker: any[] = ['Game.BankerReq', K9Proto.BankerReq, "Game.BankerRsp",K9Proto.BankerRsp, 3];

    static EnterBroadcast:any[] = [null, null, "Room.EnterBroadcast",K9Room.EnterBroadcast, 3];

    static BetReq: any[] = ['Game.BetReq', K9Proto.BetReq, "Game.BetRsp",K9Proto.BetRsp, 3];

    static BetNotify: any[] = [null, null, "Game.BetNotify",K9Proto.BetNotify, 3];

    static BankerNotify: any[] = [null, null, "Game.BankerNotify",K9Proto.BankerNotify, 3];

    static PreopenCardNotify: any[] = [null, null, "Game.PreopenCardNotify",K9Proto.PreopenCardNotify, 3];

    static AckReq:any[] = ["Game.AckReq", K9Proto.AckReq, null,null, 3];

    static MoreCardReq: any[] = ['Game.MoreCardReq', K9Proto.MoreCardReq, "Game.MoreCardRsp",K9Proto.MoreCardRsp, 3];

    static MoreCardNotify: any[] = [null, null, "Game.MoreCardNotify",K9Proto.MoreCardNotify, 3];

    static DealCardNotify: any[] = [null, null, "Game.DealCardNotify",K9Proto.DealCardNotify, 3];

    static GameSettle: any[] = [null, null, "Game.GameSettle",K9Proto.GameSettle, 3];

    static StartBroadcast: any[] = [null, null, "Room.StartBroadcast", K9Room.StartBroadcast, 3]
}